import {Component, OnInit} from '@angular/core';
import {OffersDataService} from '../_services/offers-data.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgForm} from '@angular/forms';
import {ProductsListModel} from '../../../shared/models/productsList.model';
import {PersonalNotesModel} from '../../../shared/models/personalNotes.model';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
    selector: 'app-list-offer',
    templateUrl: './list-offer.component.html',
    styleUrls: ['./list-offer.component.scss']
})

export class ListOfferComponent implements OnInit {

    constructor(private offersService: OffersDataService, private modalService: NgbModal, private snackBar: MatSnackBar) {
    }

    offersList: any = [];
    contractData: object;
    setCurrentDate: string;
    filterObjectData: object

    repeaterData: {
        personalNotes: PersonalNotesModel[];
    }
    offerDTO: any = [];

    // Pagination
    page = 1; // Page selected at start
    pageSize = 8; // How many post per page

    // Sorting
    sortName = 'offerDate'; // Sorting Name Input
    sortDirOrder = 'desc'; // Sorting Order
    totalElements: number; // Total Elements you get from the request

    // Filtering
    nameFilter: string;
    docNumberFilter: string;
    clientNameFilter: string;
    statusFilter: any = '';

    ngOnInit() {

        this.repeaterData = {
            personalNotes: []
        }
        this.addPersonalNotes();

        this.setCurrentDate = new Date().toISOString().split('T')[0];

        this.listOfferFilter();

    }

    listOfferFilter() {
        this.filterObjectData = {
            name: this.nameFilter != "" ? this.nameFilter : undefined,
            docNumber: this.docNumberFilter != "" ? this.docNumberFilter : undefined,
            clientName: this.clientNameFilter != "" ? this.clientNameFilter : undefined,
            status: this.statusFilter !== '' ? this.statusFilter : undefined
        }

        this.offersService.listOfferFilter(this.pageSize, this.page, this.sortName, this.sortDirOrder, this.filterObjectData).subscribe((resp: any) => {
            this.offersList = resp.content;
            this.totalElements = resp.totalElements;
        })
    }

    submitContract(form: NgForm, offerId) {

        // Repeater Object
        this.offerDTO = {
            personalNotes: form.value.personalNotes
        }

        // Personal Notes Repeater
        const personalNotesValue = [];
        for (const key of Object.keys(this.offerDTO.personalNotes)) {
            const notes = this.offerDTO.personalNotes[key];
            personalNotesValue.push(notes);
        }

        this.contractData = {
            name: form.value.contractName,
            contractDate: form.value.currentDate,
            personalNotes: personalNotesValue
        }

        this.offersService.createContractByOffer(offerId, this.contractData).subscribe(res => {
            this.openNotification('Contractul a fost creat cu succes!');
        }, error => {
            this.openNotification('A aparut o eroare!');
        })


    }

    resetForm(searchForm: NgForm){
        // this.activitySector = '';
        // this.companyActivitySubSector = '';
        // this.companyType = '';
        // this.companyEmployeesLevel = '';
        // this.rating = 0;
        searchForm.resetForm()
        this.filterObjectData = {}
        this.offersService.listOfferFilter(this.pageSize, this.page, this.sortName, this.sortDirOrder, this.filterObjectData).subscribe((resp: any) => {
            this.offersList = resp.content;
            this.totalElements = resp.totalElements;
        })

    }

    selectPageElements(event: any) {
        this.pageSize = event.target.value;
        this.page = 1;
        this.listOfferFilter();
    }

    selectSortValue(event: any) {
        this.sortName = event.target.value;
        this.page = 1;
        this.listOfferFilter();
    }

    changeOrderDirection(event: any) {
        this.sortDirOrder = event.target.value;
        this.page = 1;
        this.listOfferFilter();
    }

    onPageChange(page: number) {
        this.page = page;
        this.listOfferFilter();
    }


    // Personal Notes Repeater -- Start
    addPersonalNotes() {
        this.repeaterData.personalNotes.push({
            author: '',
            note: '',
            date: undefined
        });
    }

    removePersonalNotes(index: number) {
        this.repeaterData.personalNotes.splice(index, 1);
    }


    open(content) {
        this.modalService.open(content)
    }


    openNotification(message) {
        this.snackBar.open(message, 'Inchide', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
        });
    }

}
